import NiceModal from "@ebay/nice-modal-react";
import type { useSingleton } from "@tippyjs/react";
import { BOARD_MANE_SET_V2 } from "@/api/apiEndpoints";
import { canv } from "@/canv/global";
import { escapeString, MakeRequest } from "@/canv/utils";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import styles from "@/interface/HeaderBar/LeftBar/LeftBar.module.css";
import { RenameBoardModal } from "@/interface/HeaderBar/LeftBar/RenameBoardModal";
import { Tooltip } from "@/interface/ui/Tooltip";
import { decodeHtml } from "@/shared/lib/decodeHtml";

type Props = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    boardName: string;
};

export const BoardNameField = ({ singletoneTarget, boardName }: Props) => {
    const openRenameModal = async () => {
        if (canv.isGrantedAccess() || !canv.isBoardModeEditOrOwner()) {
            return;
        }
        const newName = (await NiceModal.show(RenameBoardModal, { boardName })) as string;

        if (newName && newName !== boardName) {
            const value = newName.slice(0, 250) || "";
            await MakeRequest(
                BOARD_MANE_SET_V2,
                {
                    boardUID: canv.getInitDataProp("boardUID"),
                    name: value,
                    token: canv.getInitDataProp("userToken"),
                },
                true,
            );

            document.title = value;

            canv.setInitDataProp("boardName", escapeString(value));
            canv.appInterface.infoWindow.open("Сохранено");
        }
    };

    return (
        <Tooltip singleton={singletoneTarget} content="Переименовать">
            <BottomBarItem className={styles.boardName} onClick={openRenameModal}>
                {decodeHtml(boardName)}
            </BottomBarItem>
        </Tooltip>
    );
};
